import React from 'react';
import Paper from "@mui/material/Paper";
import { Card, CardContent, TextField, Typography, CardMedia } from '@mui/material';
import { ProductFamilyImageView } from './ProductImageView';

function productFamilyPaper(content) {
    return (<Paper variant="elevation" elevation={1}><Card sx={{width: 256, height:190}}>
        {content}
        </Card></Paper>
    )
}

const ProductFamilyCard = (family) => {
    return productFamilyPaper(<>
            <ProductFamilyImageView family_id={family.id} width={256} height={140} />
            <CardContent>
                <Typography variant="subtitle1" textAlign="center" sx={{position: "relative", "top": "10"}}>{family.name}</Typography>
            </CardContent>
        </>
    )
}

const OthersFamilyCard = () => {
  return <Paper variant="elevation" elevation={1}>
    <Card sx={{width: 256, height:190}}>
      <CardMedia  sx={{width: 256, height: 140}} />
      <CardContent>
        <Typography variant="subtitle1" textAlign="center" sx={{position: "relative", "top": "10"}}>Other Products</Typography>
      </CardContent>
    </Card>
  </Paper>
}

export default ProductFamilyCard;
export { ProductFamilyCard, OthersFamilyCard };